var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafetyOperation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "safetyOperation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "927-\\u7AD9\\u70B9\\u8FD0\\u8425\\u6982\\u89C8",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "927-\\u7AD9\\u70B9\\u8FD0\\u8425\\u6982\\u89C8-\\u5206\\u65F6\\u7EDF\\u8BA1",
    transform: "translate(-374.000000, -604.000000)",
    fill: "#16DD8E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3",
    transform: "translate(358.000000, 592.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "safetyOperation",
    transform: "translate(16.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    opacity: 0,
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5453125,2.6546875 L8.2359375,0.8453125 C8.171875,0.8234375 8.0859375,0.8125 8,0.8125 C7.9140625,0.8125 7.828125,0.8234375 7.7640625,0.8453125 L2.4546875,2.6546875 C2.325,2.6984375 2.21875,2.8484375 2.21875,2.9859375 L2.21875,10.5234375 C2.21875,10.6609375 2.3078125,10.8421875 2.415625,10.928125 L7.8015625,15.125 C7.85625,15.1671875 7.9265625,15.1890625 7.9984375,15.1890625 C8.0703125,15.1890625 8.1421875,15.1671875 8.1953125,15.125 L13.58125,10.928125 C13.6890625,10.84375 13.7781922,10.6625 13.7781922,10.5234375 L13.7781922,2.9859375 C13.78125,2.8484375 13.675,2.7 13.5453125,2.6546875 Z M10.8515625,5.3234375 L7.5296875,9.896875 C7.4296875,10.034375 7.2234375,10.034375 7.1234375,9.896875 L5.1484375,7.178125 C5.0890625,7.0953125 5.1484375,6.9796875 5.25,6.9796875 L6.1125,6.9796875 C6.1921875,6.9796875 6.26875,7.01875 6.315625,7.0828125 L7.3265625,8.4734375 L9.684375,5.2265625 C9.73125,5.1625 9.80625,5.1234375 9.8875,5.1234375 L10.75,5.1234375 C10.8515625,5.125 10.9109375,5.240625 10.8515625,5.3234375 Z",
    id: "\\u5F62\\u72B6"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyOperation);
export default __webpack_public_path__ + "static/media/safetyOperation.2ff963499d0b89ae60d91b6cd08dec2f.svg";
export { ForwardRef as ReactComponent };